var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import "./styles.scss";
import { ConditionalWrap } from "@react-components/primitives/ConditionalWrap/ConditionalWrap";
import { Breadcrumb } from "@react-components/ui/Breadcrumb/Breadcrumb";
var ContentCard = function (_a) {
    var heading = _a.heading, manchet = _a.manchet, url = _a.url, breadcrumb = _a.breadcrumb;
    return (_jsxs("div", __assign({ className: "content-card" }, { children: [breadcrumb && breadcrumb.length && (_jsx("div", __assign({ className: "content-card__breadcrumb-wrap" }, { children: _jsx(Breadcrumb, { collection: breadcrumb }, void 0) }), void 0)), _jsx(ConditionalWrap, __assign({ condition: !!url, wrap: function (children) { return (_jsx("a", __assign({ className: "content-card__link", href: url }, { children: children }), void 0)); } }, { children: _jsx(_Fragment, { children: heading && (_jsx("h3", { className: "content-card__heading", dangerouslySetInnerHTML: { __html: heading } }, void 0)) }, void 0) }), void 0), manchet && _jsx("p", __assign({ className: "content-card__manchet" }, { children: manchet }), void 0)] }), void 0));
};
export { ContentCard };
